const LANGUAGE_KEY = 'user_language_preference';
const SUPPORTED_LANGUAGES = ['fr', 'en'];
const DEFAULT_LANGUAGE = 'fr';

export function detectLanguage() {
  const stored = localStorage.getItem(LANGUAGE_KEY);
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
    return stored;
  }

  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0].toLowerCase();

  if (SUPPORTED_LANGUAGES.includes(langCode)) {
    return langCode;
  }

  return DEFAULT_LANGUAGE;
}

export function saveLanguagePreference(lang) {
  if (SUPPORTED_LANGUAGES.includes(lang)) {
    localStorage.setItem(LANGUAGE_KEY, lang);
  }
}

export function getStoredLanguage() {
  return localStorage.getItem(LANGUAGE_KEY);
}
